import { useState } from 'react';
import { ARTICLES } from '../lib/data';
import { useI18n } from '../i18n';
import { X } from 'lucide-react';
import LivingImage from '../components/living/LivingImage';
import Tilt from '../components/living/Tilt';

// List cards are ~420px wide: a 720px picture is sharp and loads much faster.
const cardImage = (url) => url.replace(/([?&])w=1200/, '$1w=720');

export default function Opdag() {
    const { t, locale } = useI18n();
    const [open, setOpen] = useState(null);

    return (
        <div className="px-5 pt-10 pb-32 max-w-2xl mx-auto">
            <p className="text-[10px] uppercase tracking-widest font-semibold text-brand-ink3">
                {locale === 'da' ? 'Have-guides & artikler' : 'Garden guides & articles'}
            </p>
            <h1 className="font-serif text-3xl sm:text-4xl text-brand-ink mt-1 mb-8">{t('discover.title')}</h1>

            <div className="space-y-4 stagger">
                {ARTICLES.map((a, i) => (
                    <Tilt
                        as="button"
                        key={a.id}
                        data-testid={`article-${a.id}`}
                        onClick={() => setOpen(a)}
                        max={5}
                        className="block w-full text-left bg-brand-card border border-brand-border rounded-3xl overflow-hidden"
                    >
                        <div className="relative aspect-[16/9] overflow-hidden bg-brand-bg2">
                            <LivingImage src={cardImage(a.image)} eager={i < 2} className="w-full h-full" />
                            {a.featured && (
                                <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest font-semibold bg-brand-terracotta text-white px-3 py-1 rounded-full">
                                    {t('discover.featured')}
                                </span>
                            )}
                        </div>
                        <div className="p-5">
                            <span className="text-[10px] uppercase tracking-widest font-semibold text-brand-green">{a.tag[locale] || a.tag.en || a.tag.da}</span>
                            <h3 className="font-serif text-xl text-brand-ink mt-1">{a.title[locale] || a.title.en || a.title.da}</h3>
                            <p className="text-sm text-brand-ink2 mt-2 leading-relaxed">{a.excerpt[locale] || a.excerpt.en || a.excerpt.da}</p>
                        </div>
                    </Tilt>
                ))}
            </div>

            {open && (
                <div className="fixed inset-0 z-[60] bg-brand-ink/40 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={() => setOpen(null)}>
                    <div className="bg-brand-bg w-full sm:max-w-2xl rounded-t-3xl sm:rounded-3xl border border-brand-border max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                        <div className="aspect-[16/9] overflow-hidden">
                            <LivingImage src={open.image} className="w-full h-full" />
                        </div>
                        <div className="p-6">
                            <div className="flex items-start justify-between mb-3">
                                <span className="text-[10px] uppercase tracking-widest font-semibold text-brand-green">{open.tag[locale] || open.tag.en || open.tag.da}</span>
                                <button onClick={() => setOpen(null)} className="p-2 hover:bg-brand-bg2 rounded-full -mr-2 -mt-2"><X size={18} /></button>
                            </div>
                            <h2 className="font-serif text-3xl text-brand-ink leading-tight">{open.title[locale] || open.title.en || open.title.da}</h2>
                            <p className="text-base text-brand-ink2 mt-5 leading-relaxed whitespace-pre-line">{open.body[locale] || open.body.en || open.body.da}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
